var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.950935 2.12471L5.11422 5.84301C5.21945 5.9375 5.35712 5.98993 5.49999 5.98993C5.64286 5.98993 5.78052 5.9375 5.88576 5.84301L10.049 2.12471C9.97081 2.08694 9.88472 2.06732 9.79747 2.06738H1.2025C1.11525 2.06731 1.02916 2.08692 0.950935 2.12471ZM0.711905 8.41424C0.65896 8.32791 0.631049 8.22912 0.631165 8.12846V2.62613C0.631049 2.52548 0.65896 2.42669 0.711905 2.34036L4.11223 5.3773L0.711905 8.41424ZM4.35247 5.59241L4.89609 6.07791C5.06086 6.22575 5.27635 6.30778 5.49999 6.30778C5.72362 6.30778 5.93911 6.22575 6.10389 6.07791L6.64751 5.59241L10.049 8.62988C9.97081 8.66767 9.88472 8.68729 9.79747 8.68721H1.2025C1.11525 8.68729 1.02916 8.66767 0.950935 8.62988L4.35247 5.59241ZM6.88775 5.3773L10.2881 2.34036C10.341 2.42669 10.3689 2.52548 10.3688 2.62613V8.12846C10.3689 8.22912 10.341 8.32791 10.2881 8.41424L6.88775 5.3773Z",
    fill: "#667689"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.a71e16fcd532ab50a35801f3221ba8ba.svg";
export { ForwardRef as ReactComponent };